// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Greece from '../_raw/flag/icon_flag_greece.png';

export default () => <img src={Greece} alt="Greece" />;
